<script>
export default {
    name: 'IconChevron',
    props: {
        direction: { type: String, default: 'left' },
    }
};
</script>

<template>
    <span :class="`icon icon--chevron-${direction}`">
        <svg role="img" :title="`icon: chevron-${direction}`">
            <use :href="`/assets/v-638696888280000000/icons/common/ui.svg#chevron-${direction}`"></use>
        </svg>
    </span>
</template>

<style scoped>

</style>